
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/typescript-learning-path",
      function () {
        return require("private-next-pages/typescript-learning-path.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/typescript-learning-path"])
      });
    }
  